import { render, staticRenderFns } from "./ReservationColumnSetting.vue?vue&type=template&id=4fdd7dec&scoped=true&"
import script from "./ReservationColumnSetting.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnSetting.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnSetting.vue?vue&type=style&index=0&id=4fdd7dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdd7dec",
  null
  
)

export default component.exports